import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';


// import { BehaviorSubject } from 'rxjs';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GestorStatusService {

  private mensajeOrigen = new Subject<any>();
  private anioProducto = new Subject<number>();

  mensajeActual = this.mensajeOrigen.asObservable();
  getAnioProducto = this.anioProducto.asObservable();

  constructor(
    private http:HttpClient
  ) { }

  puenteDatos(datos: any) {
    this.mensajeOrigen.next(datos);
  }
  enviaAnioProd(anio: number) {
    this.anioProducto.next(anio);
  }

  getInfoEmpresa(idEmpresa:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa);
  }

  // SERVICIOS DE CERTIFICAR
  getAllStatus(datos:any){
    // let datos: any = {fechaCertificar: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatuses + localStorage.getItem('empresaIDInfo'), datos);
  }

  guardaStatusStep(datos: any, anio:number){
    datos.fechaCertificar = anio;
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + localStorage.getItem('empresaIDInfo'), datos);
  }

  getSeccionesCertificar(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getSeccionesCertificar + localStorage.getItem('empresaIDInfo'), datos)
  }
}
